import { InputBaseClassKey, InputBaseProps } from '@material-ui/core/InputBase'
import { StyleRules } from '@material-ui/core/styles/withStyles'
import { atlasTextBody } from 'components/atlas-components/typography'

export const MuiInputBase: Partial<StyleRules<InputBaseClassKey, InputBaseProps>> = {
    root: {
        ...atlasTextBody
    }
}
